import React from "react";

export default function FooterSocialLink(props) {
  return (
    <a
      href={props.link}
      className="mb-2 d-flex justify-content-start align-items-center gap-2"
    >
      <i className={`fa-brands ${props.icon}`}></i>
      <span>{props.label}</span>
    </a>
  );
}
